import React, { useState, useEffect } from 'react';
import theme1 from '../Components/Themes/Theme1';
import { useNavigate } from 'react-router-dom';
// import Icon from '../Components/introoptionicon';
import { saveAnswer } from '../Apis/endpoints'; // Adjust the import path
import { SvgBackground ,BackIcon, Icon} from "../Components/Themes/Theme1";


const Intro1 = () => {
  const [selectedOption, setSelectedOption] = useState(null);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const navigate = useNavigate();
  const user = localStorage.getItem('user');
  const question1 = "What is your profession?";
  const options = [
    { id: 1, text: "Student" },
    { id: 2, text: "Working Professional" },
    { id: 3, text: "Educator" },
    { id: 4, text: "Just Learning a Language" },
  ];

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const handleOptionClick = async (optionId) => {
    setSelectedOption(optionId);
    const selectedAnswer = options.find((option) => option.id === optionId).text;
    navigate("/intro2", );

    try {
      // Save the answer to the backend
      await saveAnswer(question1, selectedAnswer);

      // Redirect to the next page
      setTimeout(() => {
       
      }, 500);
    } catch (error) {
      console.error("Error saving answer:", error);
    }
  };

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: isMobile ? 'column' : 'row',
        flexWrap: 'wrap',
        height: '100vh',
      }}
    >
      <div className="flex flex-1 justify-center items-center p-8 min-w-[50%]" 
          style={{
            flexDirection: 'column',
            backgroundImage: "url('/images/background.svg')",
            backgroundSize: "cover",
            backgroundRepeat: "no-repeat",
            backgroundPosition: "center",
          }}
         >
        <h1 className='ml-4'
        style={{
          fontSize: isMobile ? '2.5rem' : '3.5rem',
          marginLeft:"30px",
        }}>
          <span className="mb-8 text-[#002952] font-semibold ms-7" style={{ fontSize: '36px' }}>Welcome to ComSki,</span>
          <span className="mb-8 text-[#2C72F2] font-semibold" style={{ fontSize: '36px' }}>{user}</span>
        </h1>
        <div className="w-full max-w-[30rem] p-8 text-left">
          <h2 className="mb-8 text-[#002952] text-lg font-semibold">{question1}</h2>
          {options.map((option) => (
            <div
              key={option.id}
              onClick={() => handleOptionClick(option.id)}
              className={`flex items-center p-4 my-6 w-[80%] max-w-[20rem] rounded-lg cursor-pointer transition-all duration-300 shadow-md ${
                selectedOption === option.id
                  ? "bg-[#2C72F2] text-white"
                  : "bg-[#FFFFFF] text-[#002952]"
              }`}
            >
              <span
                className={`mr-3 flex items-center justify-center text-lg ${
                  selectedOption === option.id ? "text-white" : "text-gray-800"
                }`}
              >
                <img
                  src="/images/onboard-icon.svg" // Update this path based on your actual file location
                  alt="Option Icon"
                  className=" mx-4 w-6 h-6 sm:w-8 sm:h-8 md:w-5 md:h-5"
                />
              </span>
              {option.text}
            </div>
          ))}
          <div className="mt-4">
            <a href="/upload" className="text-[#002952] underline text-base">
              Skip
            </a>
          </div>
      </div>
    </div>
      {!isMobile && (
        <div
          style={{
            flex: 1,
            backgroundColor: '#ffff',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            padding: '2rem',
            minWidth: '50%',
          }}
        >
          <img
            src="/images/Soft_Skills.svg"
            alt="Soft Skills"
            style={{
              width: '100%',
              maxWidth: '30rem',
              height: 'auto',
              aspectRatio: '1',
            }}
          />
        </div>
      )}
    </div>
  );
};

export default Intro1;
